import { useMutation } from '@tanstack/react-query'
import { downloadAwardedStudentsReport } from './requests'

type UseDownloadAwardedStudentsReportOptions = {
  onSuccess?: (blob: Blob) => void
  onError?: (error: Error) => void
}

export const useDownloadAwardedStudentsReport = (
  options?: UseDownloadAwardedStudentsReportOptions
) => {
  return useMutation({
    mutationFn: downloadAwardedStudentsReport,
    onSuccess: (blob) => {
      options?.onSuccess?.(blob)
    },
    onError: (error: Error) => {
      options?.onError?.(error)
    },
  })
}
